import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup-overlay"
}
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = ["src"]

import { ref } from 'vue'
import warningImage from '@/assets/image/warning.png'


export default /*@__PURE__*/_defineComponent({
  __name: 'WarningPopup',
  setup(__props) {

const visible = ref(true)
const popupImage = warningImage
const closePopup = () => {
  visible.value = false
}


return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(popupImage),
            alt: "주의사항 팝업"
          }, null, 8, _hoisted_3),
          _createElementVNode("button", {
            class: "popup-close",
            onClick: closePopup
          }, " 확인 ")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})